import React, { useState, useEffect, useCallback } from "react";
import { Container } from "./styles";
import { producaov2 } from "../../../../services/apis";
import * as dateFNS from 'date-fns';
import { FaCheckSquare, FaWindowClose } from 'react-icons/fa'

import {
  Box,
  Button,
  CircularProgress,
  Collapse,
  FormControl,
  IconButton,
  InputLabel,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Toolbar,
  Typography,
  Checkbox,
  FormControlLabel,
} from '@material-ui/core';
import { FilterList, KeyboardArrowDown, KeyboardArrowUp, HighlightOff } from '@material-ui/icons';


function EmptyTable() {
  return (
    <Box
      position="absolute"
      top="0"
      bottom="0"
      left="0"
      right="0"
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      Nenhum projeto encontrado com esse filtro
    </Box>
  )
}

function LoadingTable() {
  return (
    <Box
      position="absolute"
      top="0"
      bottom="0"
      left="0"
      right="0"
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <CircularProgress />
    </Box>
  )
}

const formatDate = (date) => {
  return dateFNS.format(new Date(date), 'dd/MM/yyyy')
}

const useTableStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    height: "60vh",
    overflow: 'auto',
    position: "relative",
  },
  body: {

  },
  headCell: {
    wordBreak: 'keep-all',
    whiteSpace: 'nowrap'
  },
  projectSelect: {
    minWidth: '160px',
    display: "flex",
    flexGrow: 1,
    flexShrink: 1,
  },
  approvalSelect: {
    minWidth: '180px',
    display: "flex",
    flexGrow: 1,
    flexShrink: 1,
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "1rem",
    flexWrap: "wrap",
    paddingTop: "1rem"
  },
  toolbarInputs: {
    display: "flex",
    gap: "2rem",
    flexGrow: 1,
    flexShrink: 1,
  },
  toolbarButtons: {
    display: "flex",
    gap: "10px"
  }
});


const GeneralDataCS = ({data_i, data_f}) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const tableStyles = useTableStyles();
  // const getPassDate = () => {
  //   const today = new Date();
  //   return new Date(today.setMonth(today.getMonth() - 1));
  // };

  const [params, setParams] = useState({
    page: 1,
    search: '',
    limit: 30,
    isMba: false,
    isPaying: false,
    isMC: false,
    isPPA: false,
    isTrail: false,
    date_initial: data_i,
    date_end: data_f,
    isPro: false,
    isDoc: false
  });


  const searchValuesWithFilters = useCallback(async () => {
    setLoading(true);
    producaov2.get(`/admin/table-customer-success-v2`, { params })
      .then(res => {
        if (res.data) {
          setData(res.data.data);
          setTotalPage(res.data.count);
          setLoading(false);
        }

      })
  }, [params])


  useEffect(() => {
    searchValuesWithFilters();
  }, []);

  function ListPedidos({
    step,
    id_pessoa,
    onUpdateData = () => { }
  }) {

    return (
      <TableRow component={"a"} href={`/admin/alunos/detalhes/${id_pessoa}#cursos`} target="_blank">
        <TableCell>{step?.curso}</TableCell>
        <TableCell>
          {step.amount}
        </TableCell>
        <TableCell>
          {step.installments}
        </TableCell>
        <TableCell>
          {step.payment_method}
        </TableCell>
        <TableCell
          style={{
            maxWidth: "200px",
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            flexWrap: 'wrap'
          }}
        >
          {step.observation || "N/A"}
        </TableCell>
        <TableCell>{formatDate(step?.data_buy)}</TableCell>
      </TableRow>
    );
  }
  function ListPessoas({ ...props }) {
    const [isOpen, setIsOpen] = useState(false);
    return (
      <>
        <TableRow>
          <TableCell>
            {props?.pedidos.length > 0 && (
              <Button
                size="small"
                variant="text"
                endIcon={isOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                onClick={() => setIsOpen(prev => !prev)}
              >
                Pedidos
              </Button>
            )}
          </TableCell>
          <TableCell
            component={"a"}
            href={`/admin/dashboard/aluno/${props.id_pessoa}`}
          >
            <Typography variant="body2">{props.name}</Typography>
            <Typography variant="body2">{props.email}</Typography>
            <Typography variant="body2">{formatDate(props?.register)}</Typography>
          </TableCell>
          <TableCell>{props?.is_paying ? <FaCheckSquare color="green" /> : <FaWindowClose color="red" />}</TableCell>
          <TableCell>{props?.is_pro ? <FaCheckSquare color="green" /> : <FaWindowClose color="red" />}</TableCell>
          <TableCell style={{
            textAlign: 'center',
          }}>
            <Typography variant="body2">
              {props?.is_mba ? <FaCheckSquare color="green" /> : <FaWindowClose color="red" />}
            </Typography>
            {props?.is_mba && (
              <Typography component={"a"} href={`/admin/dashboard/aluno/${props.id_pessoa}?ref=mba`} target="_blank" style={{ display: 'block' }} variant="body2">
                Acessar
              </Typography>

            )}
          </TableCell>
          <TableCell
            style={{
              textAlign: 'center',
            }}
          >
            {props?.id_doc ? <FaCheckSquare color="green" /> : <FaWindowClose color="red" />}
            {props?.is_mba && !props?.id_doc && <Typography component={"a"} href={`/admin/dashboard/aluno/${props.id_pessoa}?ref=mba`} target="_blank" style={{ display: 'block' }} variant="body2">Marcar Envio</Typography>}
          </TableCell>
          <TableCell>
            <Typography
              style={{
                textAlign: 'center',
                // display: 'flex',
                // flexDirection: 'column'
              }}
              variant="body2">{props?.has_skills_mapping ? <FaCheckSquare color="green" /> : <FaWindowClose color="red" />}</Typography>
            {props?.has_skills_mapping && <Typography component={'a'} href={`/admin/alunos/mapeamento-de-competencias?id_aluno=${props.id_pessoa}`} target="_blank" variant="body2">Acessar</Typography>}
          </TableCell>
          <TableCell>
            <Typography
              style={{
                textAlign: 'center',
              }}
              variant="body2">

              {props?.has_ppa ? <FaCheckSquare color="green" /> : <FaWindowClose color="red" />}
            </Typography>
            {
              props?.has_ppa  && (
            <Typography component={"a"} href={`/admin/operacoes?id_aluno=${props.id_pessoa}#projetos`} target="_blank" style={{ display: 'block' }} variant="body2">
              Acessar
            </Typography>
              )
            }

          </TableCell>
          <TableCell>{props?.has_trail ? <FaCheckSquare color="green" /> : <FaWindowClose color="red" />}</TableCell>
          <TableCell style={{
            maxWidth: "220px",
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            flexWrap: 'wrap',
          }}>
            <Typography style={{ display: 'block' }} variant="body2">
              {(props?.observation.slice(0, 50) + "...") || "N/A"}
            </Typography>
            <Typography component={"a"} href={`/admin/alunos/detalhes/${props.id_pessoa}#observacao`} target="_blank" style={{ display: 'block' }} variant="body2">
              {props?.observation == "N/A" ? "Criar Obs" : "Editar Obs"}
            </Typography>

          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Curso</TableCell>
                      <TableCell>Valor Pago</TableCell>
                      <TableCell>Parcelas</TableCell>
                      <TableCell>Método</TableCell>
                      <TableCell>Observação</TableCell>
                      <TableCell>Data Compra</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {props.pedidos?.map(step => {
                      return <ListPedidos key={step?.id} step={step} id_pessoa={props.id_pessoa} onUpdateData={() => console.log("update")} />
                    })}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    )
  }
  const handleDeleteFilters = (e) => {
    setParams({
      page: 1,
      search: '',
      limit: 30,
      isMba: false,
      isPaying: false,
      isMC: false,
      isPPA: false,
      isTrail: false,
      date_initial: "",
      date_end: "",
      isPro: false,
      isDoc: false
    });
  }

  return (
    <>
      <Container>
        <h2>
          Detalhamento | Alunos
        </h2>
        <Paper>
          <Toolbar className={tableStyles.toolbar} >
            <Box className={tableStyles.toolbarInputs}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={params.isMba}
                    onChange={e => setParams(prev => ({ ...prev, isMba: !prev.isMba }))}
                    name="isMba"
                    color="primary"
                    id="isMba"
                  />
                }
                label="MBA"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={params.isPro}
                    onChange={e => setParams(prev => ({ ...prev, isPro: !prev.isPro }))}
                    name="isPro"
                    color="primary"
                    id="isPro"
                  />
                }
                label="PRO"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={params.isDoc}
                    onChange={e => setParams(prev => ({ ...prev, isDoc: !prev.isDoc }))}
                    name="isDoc"
                    color="primary"
                    id="isDoc"
                  />
                }
                label="Doc"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={params.isPaying}
                    onChange={e => setParams(prev => ({ ...prev, isPaying: !prev.isPaying }))}
                    name="isPaying"
                    color="primary"
                    id="isPaying"
                  />
                }
                label="Pagantes"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={params.isMC}
                    onChange={e => setParams(prev => ({ ...prev, isMC: !prev.isMC }))}
                    name="isMC"
                    color="primary"
                    id="isMC"
                  />
                }
                label="Mapeamento de Competências"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={params.isPPA}
                    onChange={e => setParams(prev => ({ ...prev, isPPA: !prev.isPPA }))}
                    name="isPPA"
                    color="primary"
                    id="isPPA"
                  />
                }
                label="PPA"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    id="isTrail"
                    checked={params.isTrail}
                    onChange={e => setParams(prev => ({ ...prev, isTrail: !prev.isTrail }))}
                    name="isTrail"
                    color="primary"
                  />
                }
                label="Trilha"
              />
            </Box>
            <Box className={tableStyles.toolbarButtons}>
              <TextField label="Aluno" value={params.search || ""} onChange={e => {
                const value = e.target.value;
                setParams(prev => ({ ...prev, search: value }));
              }} />
              <TextField
                id="date-initial"
                label="Data Inicial"
                type="date"
                defaultValue={params.date_initial}
                onChange={e => setParams(prev => ({ ...prev, date_initial: e.target.value }))}
                // style={{
                //   marginRight:"1rem"
                // }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                id="date-final"
                label="Data Final"
                type="date"
                defaultValue={params.date_end}
                onChange={e => setParams(prev => ({ ...prev, date_end: e.target.value }))}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <IconButton
                variant="contained"
                color="primary"
                type="button"
                onClick={() => searchValuesWithFilters()}
                style={{
                  fontSize: "1rem"
                }}
              >
                Aplicar Filtro <FilterList />
              </IconButton>
              {(params.isMba || params.isPaying || params.isMC || params.isTrail || params.search || params.isPPA) && (
                <IconButton
                  variant="outlined"
                  color="primary"
                  type="button"
                  onClick={handleDeleteFilters}
                >
                  <HighlightOff />
                </IconButton>
              )}
            </Box>
          </Toolbar>
          <TableContainer className={tableStyles.container}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {/* <TableCell>
                {isRefreshing && <CircularProgress size={16} />}
              </TableCell> */}
                  <TableCell className={tableStyles.headCell}></TableCell>
                  <TableCell className={tableStyles.headCell}>Aluno</TableCell>
                  <TableCell className={tableStyles.headCell}>Pago</TableCell>
                  <TableCell className={tableStyles.headCell}>Pro</TableCell>
                  <TableCell className={tableStyles.headCell}>MBA</TableCell>
                  <TableCell className={tableStyles.headCell}
                    style={{
                      textAlign: 'center',
                      // display: 'flex',
                      // flexDirection: 'column'
                    }}
                  >Doc</TableCell>
                  <TableCell className={tableStyles.headCell}
                    style={{
                      textAlign: 'center',
                      // display: 'flex',
                      // flexDirection: 'column'
                    }}
                  >MC</TableCell>
                  <TableCell className={tableStyles.headCell}>PPA</TableCell>
                  <TableCell className={tableStyles.headCell}>Trilhas</TableCell>
                  <TableCell className={tableStyles.headCell}>Observação</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className={tableStyles.body}>
                {loading && <LoadingTable />}
                {(!loading && data?.length === 0) && <EmptyTable />}
                {!loading && (
                  <>
                    {data?.map(person => {
                      return <ListPessoas key={person?.id} {...person} onUpdateData={() => console.log("UPDATE DATE")} />
                    })}
                  </>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {!loading && (
            <TablePagination
              component="div"
              count={totalPage}
              page={params.page}
              rowsPerPage={params.limit}
              rowsPerPageOptions={[]}
              onChangePage={(_, newPage) => setParams(prev => ({ ...prev, page: newPage }))}
            />
          )}
        </Paper>

      </Container>
    </>
  );
};

export default GeneralDataCS;
